<template>
    <div class="push">
        <h3>Time</h3>
        <v-time-picker v-model="time"></v-time-picker>
        <v-date-picker v-model="date"></v-date-picker>
        <h3>Place</h3>
        <!-- <h3>Message</h3> -->
        <!-- <v-textarea solo label="Solo textarea" v-model="text"></v-textarea>    -->
        <v-btn @click="save">Save</v-btn>     
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import { debounce } from 'lodash'
    export default {
        name: 'Push',
        props: ['notice', 'item'],
        components: {

        },
        data() {
            return {
                text: ""
            }
        },
        computed:{
            ...mapGetters(['current_feed']),
            timeDate(){
                return this.item.time[0] ? new Date(this.item.time[0]) : new Date()
            },
            time:{
                get(){
                    return `${this.timeDate.getHours()}:${this.timeDate.getMinutes()}`
                },
                set: debounce(function(newVal){
                    const data = {
                        key: 'time',
                        value:  [+new Date(this.date + ' ' + newVal)],
                    }
                    this.editNoticePush({feed_id: this.current_feed._id, notice_id: this.notice._id, push_id: this.item._id, data})
                }, 400)
            },
            date:{
                get(){
                    return `${this.timeDate.getFullYear()}-${this.timeDate.getMonth() + 1}-${this.timeDate.getDate()}`
                },
                set: debounce(function(newVal){
                    const data = {
                        key: 'time',
                        value:  [+new Date(newVal + ' ' + this.time)],
                    }
                    this.editNoticePush({feed_id: this.current_feed._id, notice_id: this.notice._id, push_id: this.item._id, data})
                }, 400)
            },
        },
        methods: {
            ...mapActions(['addNoticePush', 'editNoticePush']),
			save(){

			},
        },
}
</script>

<style lang="scss" scoped>

</style>